// extracted by mini-css-extract-plugin
module.exports = {"unauthorized-view":"unauthorized__unauthorized-view___e6XcP"};